module.exports = __webpack_public_path__ + "static/media/creador-pdf-departamentos-nova.460cf423.JPG";